import { z } from 'zod';

export const AddressZod = z.object({
    address_line1: z.string(),
    address_line2: z.string().optional(),
    city: z.string(),
    state_code: z.string().optional(),
    state_name: z.string().optional(),
    region: z.string().optional(),
    zip: z.string(),
    country_code: z.string(),
    country_name: z.string().optional(),
    full: z.string().optional(),
});
export type Address = z.infer<typeof AddressZod>;
